import React from "react";

import "./TroubleReportButtonStyle.css";
import { FaPlus } from "react-icons/fa";

const TroubleReportButton = () => {
  return (
    <a
      className="add-report"
      href="https://famos.app.uni-regensburg.de/stoerung/"
      target={"_blank"}
      rel="noreferrer"
      onClick={() => {}} // Add onClick behavior e.g. internal modal for report submission
    >
      <FaPlus />
    </a>
  );
};

export default TroubleReportButton;
